import PropTypes from 'prop-types';

/* Customize `w-62` as 15.5rem in tailwind.config.js.
In Tailwind's defaults, `w-60` is 15rem, `w-64` is 16rem. */
const LeftColumnContent = ({ children }) => (
  <aside className="w-62 mr-6">{children}</aside>
);

LeftColumnContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LeftColumnContent;
